import React, { useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Button,
} from '@mui/material';

interface SaveTitleDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  setTitle: (title: string) => void;
  onSubmit: () => Promise<void>;
  onCancel?: () => void; // Add this line

}

const SaveTitleDialog: React.FC<SaveTitleDialogProps> = ({ open, onClose, title, setTitle, onSubmit }) => {
  const [error, setError] = useState(false);

  const handleSave = async () => {
    if (!title.trim()) {
      setError(true); 
      return;
    }
    setError(false);
    await onSubmit(); 

  };
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Save Title</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Enter a title (maximum 15 characters).
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          label="Title"
          type="text"
          fullWidth
          variant="outlined"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          error={error} 
          helperText={error ? 'Please fill the title field' : ''}
          inputProps={{ maxLength: 15 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveTitleDialog;
